/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
// ==============================================
// ==================Import======================
// ==============================================

// =================Material UI==================
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

// ==================Style&IMG===================
import './style.scss';
import 'cal-heatmap/cal-heatmap.css';

// =================Highcharts===================
import Highcharts from 'highcharts';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import HighchartsReact from 'highcharts-react-official';

// =================Dependancies react==================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// =================cal-heatmap==================
import CalHeatmap from 'cal-heatmap';

// =================Components===============
import Modaldownload from './Modaldownload';

// ===================Actions====================
import {
  saveDateElements,
  setDateHighlight,
  setDatePickerDateFrom,
  setDatePickerDateTo,
  setDateSelectedArray,
  setDownloadButton,
  setHeatmapOptions,
  setLinearOptions,
  setShiftKey,
} from '../../../actions/metadata';
import { fetchCalendarData } from '../../../actions/dataAPI';
import { globalConfig } from '../../../configuration/config';

function Data() {
  // ========================State Elements===================
  const datePickerDateFrom = useSelector((state) => state.metadata.data.datePicker.dateFrom);
  const datePickerDateTo = useSelector((state) => state.metadata.data.datePicker.dateTo);
  const saveFullData = useSelector((state) => state.metadata.data.saveFullData);
  const stationFullData = useSelector((state) => state.metadata.data.stationFullData);
  const currentDate = useSelector((state) => state.metadata.data.currentDate);
  const heatmapOptions = useSelector((state) => state.metadata.data.heatmap.options);
  const linearOptions = useSelector((state) => state.metadata.data.linear.options);
  const shiftkeypressed = useSelector((state) => state.metadata.data.shiftkey);
  const calendarData = useSelector((state) => state.metadata.data.calendar.calendarData);
  const dateElements = useSelector((state) => state.metadata.data.calendar.dateElements);
  const dateSelectedArray = useSelector((state) => state.metadata.data.calendar.dateSelectedArray);
  const dateHighlight = useSelector((state) => state.metadata.data.calendar.dateHighlight);
  const dispatch = useDispatch();

  // ============HeatMap===============
  HighchartsHeatmap(Highcharts);

  // ================UseEffect cycle life==================
  // save date selected in picker by user
  useEffect(
    () => {
      if (saveFullData) {
        dispatch(setDatePickerDateFrom(stationFullData[0].date_from.substring(0, 10)));
        if (stationFullData[0].date_to === null) {
          dispatch(setDatePickerDateTo(currentDate.substring(0, 10)));
        }
        else {
          dispatch(setDatePickerDateTo(stationFullData[0].date_to.substring(0, 10)));
        }
      }
      function handleKeyDown(e) {
        if (e.keyCode === 16) {
          dispatch(setShiftKey(true));
        }
        else {
          dispatch(setShiftKey(false));
        }
      }
      document.addEventListener('keydown', handleKeyDown);
      return function cleanup() {
        document.removeEventListener('keydown', handleKeyDown);
      };
    },
    [],
  );

  // *********************************************************************************
  // * temporalchartforone function allow to display the temporal chart for one station
  // *********************************************************************************/
  function temporalchartforone(data, params) {
    const reference_dates = [];
    let fromdateofrange = '';
    let endateofrange = '';
    if (data[0].rinex_files_dates.length > 0) {
      const arraydate = data[0].rinex_files_dates;
      let firstDate = data[0].date_from.substring(0, 10);
      firstDate = Date.UTC(
        firstDate.substring(0, 4),
        firstDate.substring(5, 7) - 1,
        firstDate.substring(8, 10),
      );
      let lastDate = '';
      if (data[0].date_to === null) {
        lastDate = currentDate;
        lastDate = lastDate.substring(0, 10);
        lastDate = Date.UTC(
          lastDate.substring(0, 4),
          lastDate.substring(5, 7) - 1,
          lastDate.substring(8, 10),
        );
      }
      else {
        lastDate = data[0].date_to;
        lastDate = lastDate.substring(0, 10);
        lastDate = Date.UTC(
          lastDate.substring(0, 4),
          lastDate.substring(5, 7) - 1,
          lastDate.substring(8, 10),
        );
      }
      const data_availability_percent = {};
      let precday = '';
      for (let j = 0; j < arraydate.length; j += 1) {
        let year = arraydate[j].substring(0, 4);
        let month = arraydate[j].substring(5, 7);
        let day = arraydate[j].substring(8, 10);
        if (j === 0) {
          const new_ref_date = [];
          new_ref_date.push(Date.UTC(year, month - 1, day));
          new_ref_date.push(1);
          new_ref_date.push('begindate');
          reference_dates.push(new_ref_date);
        }
        else {
          const myday = Date.UTC(year, month - 1, day);

          if ((myday - precday) > (24 * 60 * 60 * 1000)) {
            const date_end = precday + (12 * 60 * 60 * 1000);
            let new_ref_date = [];
            new_ref_date.push(date_end);
            new_ref_date.push(1);
            new_ref_date.push('enddate');
            reference_dates.push(new_ref_date);
            new_ref_date = [];
            new_ref_date.push(date_end + (60 * 1000));
            new_ref_date.push(null);
            reference_dates.push(new_ref_date);
            new_ref_date = [];
            new_ref_date.push(myday);
            new_ref_date.push(1);
            new_ref_date.push('begindate');
            reference_dates.push(new_ref_date);
          }
        }
        precday = Date.UTC(year, month - 1, day);
        if (j === arraydate.length - 1) {
          const new_ref_date = [];
          year = arraydate[j].substring(0, 4);
          month = arraydate[j].substring(5, 7);
          day = arraydate[j].substring(8, 10);
          const date_end = Date.UTC(year, month - 1, day);
          new_ref_date.push(date_end);
          new_ref_date.push(1);
          new_ref_date.push('enddate');
          reference_dates.push(new_ref_date);
        }
      }
      // calcul data percent
      if (params.indexOf('date_range=') !== -1) {
        const startpos = params.indexOf('date_range=');
        let endpos = '';
        if (params.indexOf('&', startpos) !== -1) {
          endpos = params.indexOf('&', startpos);
        }
        else {
          endpos = params.length;
        }
        const param = params.substring(startpos + 11, endpos);
        if ((param.substring(0, 1) !== ',') && (param.length !== 21)) { // case only from date
          fromdateofrange = param.substring(0, 10);
          endateofrange = '';
        }
        else if (param.substring(0, 1) === ',') { // case only end date
          fromdateofrange = '';
          endateofrange = param.substring(1, 11);
        }
        else if (param.length === 21) { // case from and end dates
          fromdateofrange = param.substring(0, 10);
          endateofrange = param.substring(11, 21);
        }
        if (fromdateofrange !== '') {
          firstDate = Date.UTC(
            fromdateofrange.substring(0, 4),
            fromdateofrange.substring(5, 7) - 1,
            fromdateofrange.substring(8, 10),
          );
        }
        if (endateofrange !== '') {
          lastDate = Date.UTC(
            endateofrange.substring(0, 4),
            endateofrange.substring(5, 7) - 1,
            endateofrange.substring(8, 10),
          );
        }
      }

      const dateDiff = lastDate - firstDate;
      const totalDays = (dateDiff / (1000 * 3600 * 24)) + 1;
      data_availability_percent[1] = `${((arraydate.length * 100) / totalDays).toFixed(2)} % `;
      // Plot the chart
      const options = {
        chart: {
          type: 'line',
          backgroundColor: 'none',
          height: '150px',
          plotBorderWidth: 1,
          events: {},
          zooming: {
            type: 'x',
            resetButton: {
              position: {
                align: 'right',
                x: -3,
                y: 1,
              },
              theme: {
                states: {
                  hover: {
                    fill: '#21436C',
                    style: {
                      color: 'white',
                      backgroundColor: 'none',
                    },
                  },
                },
              },
            },
          },
        },
        title: {
          text: '',
        },
        legend: {
          enabled: false,
        },
        xAxis: {

          type: 'datetime',
          labels: {
            format: '{value:%e %b %Y}',
          },
        },
        yAxis: [{
          scrollbar: {
            enabled: false,
          },
          title: {
            text: '',
          },
          labels: {
            formatter: function () {
              const value = data[0].marker;
              return value !== 'undefined' ? value : this.value;
            },

          },
        },
        {
          opposite: true,
          linkedTo: 0,
          title: {
            text: '',
          },
          labels: {
            enabled: true,
            formatter: function () {
              let value = data_availability_percent[1];
              if (value === undefined) {
                value = '';
              }
              const tooltiptext = `Percent of data between ${datePickerDateFrom} and ${datePickerDateTo}`;
              return `<span title="${tooltiptext}">${value}</span>`;
            },
            useHTML: true,
          },
        },
        ],
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              symbol: 'square',
            },
          },
        },
        tooltip: {
          formatter: function () {
            let tooltip;
            if (this.key === 'begindate') {
              tooltip = `<b>Start date: </b> ${Highcharts.dateFormat('%Y-%m-%d', this.x)}<br/><b>Marker: </b> ${this.series.name}`;
            }
            else if (this.key === 'enddate') {
              tooltip = `<b>End date: </b> ${Highcharts.dateFormat('%Y-%m-%d', this.x)}<br/><b>Marker: </b> ${this.series.name}`;
            }
            return tooltip;
          },
        },
        series: [{
          name: data[0].marker,
          keys: ['x', 'y', 'name'],
          data: reference_dates,
          color: '#0199a7',
        }],

      };
      dispatch(setLinearOptions(options));
    }
  }

  // *****************************************************************************
  // * calendarheatmap function allow to display the calendar of the month selected
  // *****************************************************************************/
  function calendarheatmap(month, year) {
    let month_str;
    let total_day;
    const currentElements = { currentMonth: month, currentYear: year };
    switch (month) {
      case 'Jan':
        month_str = '01';
        total_day = 31;
        break;
      case 'Feb':
        month_str = '02';
        if (((parseInt(year, 10) % 4 === 0)
        && (parseInt(year, 10) % 100 !== 0))
        || (parseInt(year, 10) % 400 === 0)) {
          total_day = 29;
        }
        else {
          total_day = 28;
        }
        break;
      case 'Mar':
        month_str = '03';
        total_day = 31;
        break;
      case 'Apr':
        month_str = '04';
        total_day = 30;
        break;
      case 'May':
        month_str = '05';
        total_day = 31;
        break;
      case 'Jun':
        month_str = '06';
        total_day = 30;
        break;
      case 'Jul':
        month_str = '07';
        total_day = 31;
        break;
      case 'Aug':
        month_str = '08';
        total_day = 31;
        break;
      case 'Sep':
        month_str = '09';
        total_day = 30;
        break;
      case 'Oct':
        month_str = '10';
        total_day = 31;
        break;
      case 'Nov':
        month_str = '11';
        total_day = 30;
        break;
      case 'Dec':
        month_str = '12';
        total_day = 31;
        break;
      default:
    }
    const myparams = `dateRange=${year}-${month_str}-01|${year}-${month_str}-${total_day}&marker=${stationFullData[0].marker}`;
    dispatch(saveDateElements(currentElements));
    dispatch(fetchCalendarData(myparams, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
  }

  // **********************************************************************************
  // ** plotcalendar allow to display calendar
  // **********************************************************************************

  function plotCalendar(month, year) {
    let month_number;
    let month_str;
    const data_date = [];
    switch (month) {
      case 'Jan':
        month_number = 0;
        month_str = '01';
        break;
      case 'Feb':
        month_number = 1;
        month_str = '02';
        break;
      case 'Mar':
        month_number = 2;
        month_str = '03';
        break;
      case 'Apr':
        month_number = 3;
        month_str = '04';
        break;
      case 'May':
        month_number = 4;
        month_str = '05';
        break;
      case 'Jun':
        month_number = 5;
        month_str = '06';
        break;
      case 'Jul':
        month_number = 6;
        month_str = '07';
        break;
      case 'Aug':
        month_number = 7;
        month_str = '08';
        break;
      case 'Sep':
        month_number = 8;
        month_str = '09';
        break;
      case 'Oct':
        month_number = 9;
        month_str = '10';
        break;
      case 'Nov':
        month_number = 10;
        month_str = '11';
        break;
      case 'Dec':
        month_number = 11;
        month_str = '12';
        break;
      default:
    }
    // prepare the data
    let arraydate = '';
    if (calendarData.length > 0) {
      arraydate = calendarData;
      for (let i = 0; i < arraydate.length; i += 1) {
        const year_iter = arraydate[i].reference_date.substring(0, 4);
        const month_iter = arraydate[i].reference_date.substring(5, 7);
        const day_iter = arraydate[i].reference_date.substring(8, 10);
        if (`${year}-${month_str}` === arraydate[i].reference_date.substring(0, 7)) {
          data_date.push({ t: Date.UTC(year_iter, month_iter - 1, day_iter), v: 1 });
        }
      }
      // plot the calendar
      const cal = new CalHeatmap();
      if (window.screen.width > 1050) {
        cal.paint({
          itemSelector: '#cal-heatmap',
          range: 1,
          domain: {
            type: 'month',
            padding: [0, 0, 20, 0],
            label: { position: 'top' },
          },
          subDomain: {
            type: 'xDay',
            label: 'DD',
            radius: 35,
            width: 55,
            height: 55,
          },
          data: {
            source: data_date,
            type: 'json',
            x: 't',
            y: 'v',
            groupY: (d) => d[0],
          },
          date: {
            start: new Date(year, month_number + 1),
            locale: 'en',
            highlight: dateHighlight,
          },
          scale: {
            color: {
              range: ['grey', '#048b9a'],
              domain: [0, 1],
            },
          },
        });
      }
      else if (window.screen.width < 1050 && window.screen.width > 550) {
        cal.paint({
          itemSelector: '#cal-heatmap',
          range: 1,
          domain: {
            type: 'month',
            padding: [0, 0, 20, 0],
            label: { position: 'top' },
          },
          subDomain: {
            type: 'xDay',
            label: 'DD',
            radius: 25,
            width: 40,
            height: 40,
          },
          data: {
            source: data_date,
            type: 'json',
            x: 't',
            y: 'v',
            groupY: (d) => d[0],
          },
          date: {
            start: new Date(year, month_number + 1),
            locale: 'en',
            highlight: dateHighlight,
          },
          scale: {
            color: {
              range: ['grey', '#048b9a'],
              domain: [0, 1],
            },
          },
        });
      }
      else if (window.screen.width < 550) {
        cal.paint({
          itemSelector: '#cal-heatmap',
          range: 1,
          domain: {
            type: 'month',
            padding: [0, 0, 20, 0],
            label: { position: 'top' },
          },
          subDomain: {
            type: 'xDay',
            label: 'DD',
            radius: 20,
            width: 30,
            height: 30,
          },
          data: {
            source: data_date,
            type: 'json',
            x: 't',
            y: 'v',
            groupY: (d) => d[0],
          },
          date: {
            start: new Date(year, month_number + 1),
            locale: 'en',
            highlight: dateHighlight,
          },
          scale: {
            color: {
              range: ['grey', '#048b9a'],
              domain: [0, 1],
            },
          },
        });
      }
      cal.on('click', (event, t) => {
        const date = new Date(t).toLocaleDateString().split('/').reverse()
          .join('-');
        const dateselectedarray = dateSelectedArray;
        if (shiftkeypressed) {
          dateselectedarray.push(date);
          if (dateselectedarray.length === 2) {
            if (dateselectedarray[1].getDate() < dateselectedarray[0].getDate()) {
              const [valuegreatest, valuelessest] = dateselectedarray;
              dateselectedarray[0] = valuelessest;
              dateselectedarray[1] = valuegreatest;
            }
            let nextdate = dateselectedarray[0].getDate();
            let i = 1;
            while (nextdate < dateselectedarray[1].getDate()) {
              const newdate = new Date(dateselectedarray[0]);
              newdate.setDate(newdate.getDate() + i);
              const dateCalformat = new Date(
                newdate.getFullYear(),
                newdate.getMonth(),
                newdate.getDate(),
              );
              if (dateCalformat.getDate() < dateselectedarray[1].getDate()) {
                dateselectedarray.push(dateCalformat);
              }
              nextdate = dateCalformat.getDate();
              i += 1;
            }
          }
          cal.options.highlight = dateselectedarray;
          dispatch(setShiftKey(false));
        }
        else {
          let index = -1;
          for (let i = 0; i < dateselectedarray.length; i += 1) {
            if (dateselectedarray[i].valueOf() === date.valueOf()) {
              index = i;
              break;
            }
          }
          if (index > -1) {
            dateselectedarray.splice(index, 1);
          }
          else {
            dateselectedarray.push(date);
          }
          if (dateselectedarray.length !== 0) {
            cal.options.highlight = dateselectedarray;
          }
          else {
            cal.options.highlight = dateselectedarray;
          }
          dispatch(setDateSelectedArray(dateselectedarray));
          const changeDateSelectedArray = dateselectedarray.map((elem) => new Date(elem));
          dispatch(setDateHighlight(changeDateSelectedArray));
          cal.paint({
            date: {
              highlight: changeDateSelectedArray,
            },
          });
        }
      });
    }
  }

  // ************************************************************************************
  // * heatmap function allow to display the heatmap of file availability for one station
  // ************************************************************************************/
  function heatmap(data) {
    let detailflag = false;
    const percent_of_data = [];
    const list_of_years = [];
    let year_indice = 0;
    let posnextmonth = 0;
    let cpt_day = 0;
    let lastdayofmonth = '';
    let pos = 0;
    if (data[0].rinex_files_dates.length > 0) {
      // prepare the data for the timeseries
      const arraydate = data[0].rinex_files_dates;
      while (posnextmonth < arraydate.length) {
        let percent_of_month = 0;
        let total_day = 0;
        let month_number = 0;
        const year = arraydate[posnextmonth].substring(0, 4);
        const month = arraydate[posnextmonth].substring(5, 7);
        // calcul data percent
        switch (month) {
          case '01':
            total_day = 31;
            month_number = 0;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '02':
            if ((
              (parseInt(year, 10) % 4 === 0)
              && (parseInt(year, 10) % 100 !== 0))
              || (parseInt(year, 10) % 400 === 0)) {
              total_day = 29;
            }
            else {
              total_day = 28;
            }
            month_number = 1;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '03':
            total_day = 31;
            month_number = 2;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '04':
            total_day = 30;
            month_number = 3;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '05':
            total_day = 31;
            month_number = 4;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '06':
            total_day = 30;
            month_number = 5;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '07':
            total_day = 31;
            month_number = 6;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '08':
            total_day = 31;
            month_number = 7;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '09':
            total_day = 30;
            month_number = 8;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '10':
            total_day = 31;
            month_number = 9;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '11':
            total_day = 30;
            month_number = 10;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          case '12':
            total_day = 31;
            month_number = 11;
            lastdayofmonth = `${year}/${month}/${total_day}`;
            break;
          default:
        }
        while (pos < arraydate.length) {
          const iteryear = arraydate[pos].substring(0, 4);
          const itermonth = arraydate[pos].substring(5, 7);
          if (month === itermonth && year === iteryear) {
            cpt_day += 1;
          }
          else {
            break;
          }
          pos += 1;
        }

        percent_of_month = (((cpt_day) * 100) / total_day).toFixed(2);
        if (list_of_years.length === 0) {
          list_of_years.push(year);
        }
        else if (list_of_years[list_of_years.length - 1] !== year) {
          list_of_years.push(year);
          year_indice += 1;
        }
        const new_ref_date = [];
        new_ref_date.push(month_number);
        new_ref_date.push(year_indice);
        new_ref_date.push(percent_of_month);
        percent_of_data.push(new_ref_date);
        cpt_day = 0;
        total_day = 0;
        percent_of_month = 0;

        posnextmonth = pos;
      }
      // Plot the heatmap
      const options = {
        chart: {
          type: 'heatmap',
          marginTop: 50,
          marginBottom: 80,
          plotBorderWidth: 1,
          backgroundColor: 'none',
        },
        title: {
          text: 'Percent of data availability in the month',
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yAxis: {
          categories: list_of_years,
          title: {
            text: '',
          },
        },
        colorAxis: {
          min: 0,
          max: 100,
          stops: [
            [0, '#FFFFFF'],
            [0.2, '#b30000ed'],
            [0.5, '#ff7b00'],
            [1, '#0199a7'],
          ],
          minColor: '#b30000ed',
          maxColor: '#0199a7',
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          floating: true,
          x: 0,
          y: 0,
        },
        tooltip: {
          formatter: function () {
            return `<b>Date : ${this.series.xAxis.categories[this.point.x]} ${this.series.yAxis.categories[this.point.y]}</b><br><b>${this.point.value}</b> %`;
          },
        },
        plotOptions: {
          series: {
            events: {
              click: function (event) {
                detailflag = true;
                const calendarHeatmapContainer = document.getElementById('cal-heatmap');
                if (calendarHeatmapContainer.hasChildNodes()) {
                  setTimeout(() => {
                    calendarHeatmapContainer.removeChild(calendarHeatmapContainer.children[0]);
                  }, 500);
                }
                dispatch(setDateSelectedArray([]));
                dispatch(setDateHighlight([]));
                setTimeout(() => {
                  calendarheatmap(
                    event.point.series.xAxis.categories[event.point.x],
                    event.point.series.yAxis.categories[event.point.y],
                  );
                }, 100);
                setTimeout(() => {
                  dispatch(setDownloadButton(true));
                }, 1000);
              },
            },
          },
        },
        series: [{
          name: data[0].marker,
          borderWidth: 1,
          data: percent_of_data,

        }],
      };
      dispatch(setHeatmapOptions(options));
    }
  }

  // **********************************************************************************************
  // changedReferenceFromDate function allows to know what's users selected in "file date install"
  // **********************************************************************************************
  function changedReferenceFromDate(date, date_from) {
    if (date == null) {
      dispatch(setDatePickerDateFrom(date_from.substring(0, 10)));
    }
    else {
      dispatch(setDatePickerDateFrom(date));
    }
    const params = `marker=${stationFullData[0].marker}&date_range=${datePickerDateFrom},${datePickerDateTo}`;
    let arraydate = [];
    const arraydatetemp = [];
    const data = [];
    const new_station_object = {};
    const listDate = stationFullData[0].rinex_files_dates[0].split(',');
    for (let i = 0; i < listDate.length; i += 2) {
      const dt = new Date(listDate[i].slice(0, 10));
      const end = new Date(listDate[i + 1].slice(0, 10));
      while (dt <= end) {
        arraydatetemp.push(dt.toISOString().slice(0, 10));
        dt.setUTCDate(dt.getUTCDate() + 1);
      }
    }
    let startindex = arraydatetemp.indexOf(date.substring(0, 10));
    if (startindex === -1) {
      const afterdatesarray = arraydatetemp.filter(
        (d) => new Date(d) - new Date(date) > 0,
      );
      startindex = arraydatetemp.indexOf(afterdatesarray[0]);
    }
    let endindex = arraydatetemp.indexOf(datePickerDateTo.substring(0, 10));
    if (endindex === -1) {
      const beforedatesarray = arraydatetemp.filter(
        (d) => new Date(d) - new Date(datePickerDateTo) < 0,
      );
      endindex = arraydatetemp.indexOf(beforedatesarray[beforedatesarray.length - 1]);
    }
    arraydate = arraydatetemp.slice(startindex, endindex + 1);
    new_station_object.marker = stationFullData[0].marker;
    new_station_object.date_from = stationFullData[0].date_from;
    new_station_object.date_to = stationFullData[0].date_to;
    new_station_object.rinex_files_dates = arraydate;
    data.push(new_station_object);
    temporalchartforone(data, params);
    heatmap(data);
  }

  // *******************************************************************************************
  // * changedReferenceToDate function allows to know what's users selected in "file date remove"
  // *******************************************************************************************
  function changedReferenceToDate(date) {
    if (date == null) {
      const lastDate = currentDate;
      dispatch(setDatePickerDateTo(lastDate.substring(0, 10)));
    }
    else {
      dispatch(setDatePickerDateTo(date));
    }
    const params = `marker=${stationFullData[0].marker}&date_range=${datePickerDateFrom},${datePickerDateTo}`;
    let arraydate = [];
    const arraydatetemp = [];
    const data = [];
    const new_station_object = {};
    const listDate = stationFullData[0].rinex_files_dates[0].split(',');
    for (let i = 0; i < listDate.length; i += 2) {
      const dt = new Date(listDate[i].slice(0, 10));
      const end = new Date(listDate[i + 1].slice(0, 10));
      while (dt <= end) {
        arraydatetemp.push(dt.toISOString().slice(0, 10));
        dt.setUTCDate(dt.getUTCDate() + 1);
      }
    }
    let startindex = arraydatetemp.indexOf(datePickerDateFrom.substring(0, 10));
    if (startindex === -1) {
      const afterdatesarray = arraydatetemp.filter(
        (d) => new Date(d) - new Date(datePickerDateFrom) > 0,
      );
      startindex = arraydatetemp.indexOf(afterdatesarray[0]);
    }
    let endindex = arraydatetemp.indexOf(datePickerDateTo.substring(0, 10));
    if (endindex === -1) {
      const beforedatesarray = arraydatetemp.filter(
        (d) => new Date(d) - new Date(datePickerDateTo) < 0,
      );
      endindex = arraydatetemp.indexOf(beforedatesarray[beforedatesarray.length - 1]);
    }
    arraydate = arraydatetemp.slice(startindex, endindex + 1);
    new_station_object.marker = stationFullData[0].marker;
    new_station_object.date_from = stationFullData[0].date_from;
    new_station_object.date_to = stationFullData[0].date_to;
    new_station_object.rinex_files_dates = arraydate;
    data.push(new_station_object);
    temporalchartforone(data, params);
    heatmap(data);
  }

  // ****************************************************************************************
  //* initdataavailable function allow to init the temporal chart for one station and heatmap
  // ****************************************************************************************/
  function initdataavailable(data) {
    const arraydate = [];
    const results = [];
    const new_station_object = {};
    const listDate = data[0].rinex_files_dates[0].split(',');
    for (let i = 0; i < listDate.length; i += 2) {
      const dt = new Date(listDate[i].slice(0, 10));
      const end = new Date(listDate[i + 1].slice(0, 10));
      while (dt <= end) {
        arraydate.push(dt.toISOString().slice(0, 10));
        dt.setUTCDate(dt.getUTCDate() + 1);
      }
    }
    new_station_object.marker = data[0].marker;
    new_station_object.date_from = data[0].date_from;
    new_station_object.date_to = data[0].date_to;
    new_station_object.rinex_files_dates = arraydate;
    results.push(new_station_object);
    temporalchartforone(results, '');
    heatmap(results);
  }

  //  ================Use Effect Cycle life application ================

  // page launching initialisation of data
  useEffect(
    () => {
      initdataavailable(stationFullData);
    },
    [],
  );

  //  change value of date picker when state value of picker change
  useEffect(
    () => {
      if (datePickerDateFrom !== '') {
        changedReferenceFromDate(datePickerDateFrom, stationFullData[0].date_from);
      }
      if (datePickerDateTo !== '') {
        changedReferenceToDate(datePickerDateTo);
      }
    },
    [datePickerDateFrom, datePickerDateTo],
  );

  // plot new calendar when clendar data state value change
  useEffect(
    () => {
      plotCalendar(dateElements.currentMonth, dateElements.currentYear);
    },
    [calendarData],
  );

  // ===============handlers===================

  function handleChangeDateFrom(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(setDatePickerDateFrom(new Date(valuetransform).toISOString()));
  }
  function handleChangeDateTo(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(setDatePickerDateTo(new Date(valuetransform).toISOString()));
  }

  return (
    <>
      <div className="metatitle"><span>Data availability</span></div>
      <div className="datetitle">
        <h4>Data available between dates</h4>
      </div>
      <div id="datepickerrange">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              label="Range date start"
              value={dayjs(datePickerDateFrom)}
              format="YYYY.MM.DD"
              onChange={(value) => handleChangeDateFrom(value)}
            />
            <DatePicker
              label="Range date end"
              value={dayjs(datePickerDateTo)}
              format="YYYY.MM.DD"
              onChange={(value) => handleChangeDateTo(value)}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
      <HighchartsReact highcharts={Highcharts} options={linearOptions} />
      <HighchartsReact highcharts={Highcharts} options={heatmapOptions} />
      <div id="cal-heatmap" />
      <div><Modaldownload /></div>
    </>
  );
}

export default Data;
